export function XhttpRequest(urlProcessor, idForResponse, statusMessage, dataSend, SrrFunction) {
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            SrrFunction(this, idForResponse, statusMessage);
        } else {
            document.getElementById(statusMessage).innerHTML = 'Procesando...';
        }
    };
    xhttp.open('POST', urlProcessor, true);
    xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhttp.send(dataSend);
}

export function ShowRequestResp(xhttp, idForResponse, statusMessage) {
    const responseDates = JSON.parse(xhttp.responseText);
    if (responseDates.statusEvent == 1) {
        const okMessage = `<div class='info-msg'>${responseDates.messageResponse}</div>`;
        document.getElementById(idForResponse).innerHTML = okMessage;
    } else {
        document.getElementById(statusMessage).innerHTML = responseDates.messageResponse;
    }
}
